var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_wrapper c_wrapper--950 c_cs_links"},_vm._l((_vm.linksObj),function(link,index){return _c('div',{key:index},[_c('CustomerStoryLink',{attrs:{"custom-url":link.customUrl,"entry":link.entry,"asset":link.asset,"open-in-a-new-window":link.openInANewWindow,"link-label":link.linkLabel}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }